import clsx from 'clsx'
import React, {useState} from 'react'
import {useHistory} from 'react-router-dom'
import {makeStyles} from 'external/material'
import Fade from '@mui/material/Fade'
import Paper from '@mui/material/Paper'
import Box from '@mui/material/Box'
import {faEdit, faTrashAlt} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import create, {createPost} from 'helpers/command'
import Button from '@mui/material/Button'
import DialogContentText from '@mui/material/DialogContentText'
import Dialog from '../../responsive-fullscreen-dialog'
import EditableCaption from '../components/editable-caption'
import EditableHtml from '../components/editable-html'


const useStyles = makeStyles(assessmentSectionStyles)

export default function AssessmentSection ({context}) {

  const {translate} = context
  const sectionIndex = context.quizSections.findIndex(s => s.id == context.sectionId)
  const section = context.quizSections[sectionIndex] || {}
  const questions = context.quizQuestions[section.id] || []
  const loaded = section.id != undefined

  const classes = useStyles()
  const history = useHistory()
  const sectionLabel = `${section.index + 1}.`

  const [deleteSectionOpened, openDeleteSection] = React.useState(false)
  const [instructions, setInstructions] = React.useState(undefined)

  function handleOpenDeleteSection(question){
    openDeleteSection(true)
  }

  async function handleDeleteSection(confirmed) {
    if (confirmed) {
      create('quiz','deleteSection')({id: section.id})
      const {quizSections} = await context.updateState({quizSections: {
        $apply: sections =>
          sections
            .filter(q => q.id != section.id)
            .map((section,index) => ({...section, index}))
      }}) 
      const {id: sectionId} = quizSections[sectionIndex > 0 ? sectionIndex - 1 : 0] || {}
      history.push(context.link({sectionId}, `/:languageId/teacher/:page/:assessment/edit/:sectionId`))
    }
    openDeleteSection(false)
  }
	

  function handleInstructionsChanged (instructions) {
    context.updateState({quizSections: {[sectionIndex]: {instructions: {$set: instructions}}}})
    createPost('quiz', 'updateInstructions')({id: section.id, instructions})
  }
	
  return (
    // <Fade in={loaded}>
      <Paper className={classes.root}>
          <Box className={classes.header}>
            <Box className={classes.sectionName}>
              <Box className="label">{sectionLabel}</Box>
              <Title className="title" {...{context, section, sectionIndex}} />
            </Box>
            {context.quizSections.length > 1 && (
            <Box className="delete" onClick={handleOpenDeleteSection}>
              <FontAwesomeIcon icon={faTrashAlt} />
            </Box>)}
          </Box>
          <Box className={classes.content}>
            <Box className="instructions">
              <Box className="label">{translate('instructions')}:</Box>
              <EditableHtml
                key={section.id}
                context={context}
                html={section.instructions || ''}
                onChange={handleInstructionsChanged}
              />
            </Box>
          </Box>
          <Dialog
            open={deleteSectionOpened}
            close={handleDeleteSection}
            confirm={<Button variant="contained" color="primary" onClick={() => handleDeleteSection(true)}>{translate('delete')}</Button>}
            cancel={<Button variant="contained" color="secondary" onClick={() => handleDeleteSection()}>{translate('cancel')}</Button>}
            title={translate('confirm_delete_item')}
          >
            <DialogContentText>
              {translate('delete-section-message', {title: section.title || translate('unnamed'), questions: questions.length})}
            </DialogContentText>
          </Dialog>
      </Paper>
    // </Fade>
  )
}

function Title({context, className, section, sectionIndex}) {
  const {translate} = context
  const [editingTitle, setEditingTitle] = React.useState(false)

  function onEditTitleClick () {
    setEditingTitle(true)
  }

  function closeEditTitle() {
    setEditingTitle(false)
  }

  async function handleRetitle(newTitle) {
    if (newTitle == section.title) return
    context.updateState({quizSections: {
      [sectionIndex]: {title: {$set: newTitle}}
    }})
    create('quiz', 'retitleSection')({id: section.id, newTitle})
  }

  return (<Box className={className} onClick={onEditTitleClick}>
    <Box className="input">
      <EditableCaption
        editing={editingTitle}
        value={section.title || translate('section')}
        onCancel={closeEditTitle}
        onConfirm={newTitle => handleRetitle(newTitle) && closeEditTitle()}
        className="inputTitle"
      />
    </Box>
    {!editingTitle &&
    <Box className="icon">
      <FontAwesomeIcon icon={faEdit} />
    </Box>}
  </Box>)
}

function assessmentSectionStyles(theme) {
  return {
    root: {
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
    },
    header: {
      display: 'flex',
      padding: '15px 20px',
      borderBottom: 'solid 1px #aab7bf',
      color: '#69748a',
      '& .delete': {
        fontSize: '14pt',
        cursor: 'pointer'
      }
    },
    sectionName: {
      display: 'flex',
      flexGrow: 1,
      '& > .label': {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        fontSize: '13pt',
        fontWeight: 'bold'
      },
      '& > .title': {
        flexGrow: 1,
        display: 'flex',
        marginLeft: 8,
        fontSize: '12.5pt',
        '& > div': {
          display: 'flex',
          flexDirection: 'column'
        },
        '& > .title': {
          justifyContent: 'center'
        },
        '& > .icon': {
          marginLeft: 5,
          fontSize: '10pt',
          justifyContent: 'flex-start',
          cursor: 'pointer'
        },
        "& .inputTitle": {
          '& > .control': {
            display: 'flex',
          },
          '& .input': {
            border: 'none',
            color: '#69748a',
            borderBottom: '1px solid #69748',
            '&:focus': {
              outline: 'none'
            }
          },
          '& .addornment': {
            cursor: 'pointer',
            borderBottom: '1px solid #69748',
          }
        },

      }
    },
    content: {
      padding: 30,
      display: 'flex',
      flexDirection: 'column',
      '& > .instructions': {
        display: 'flex',
        flexDirection: 'column',
        '& > .label': {
          color: '#69748a',
          fontSize: '12pt',
          marginBottom: 15,
        }
      }
    }
  }
}

